var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      staticClass: "chip--select-multi",
      attrs: {
        close: "",
        color: _vm.$parent.disabled ? "grey" : "secondary",
        "text-color": "whitePure"
      },
      on: { input: _vm.handleRemove }
    },
    [
      _c("v-icon", { attrs: { color: "white" } }, [_vm._v(_vm._s(_vm.coIcon))]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "multiple-selected-item",
          staticStyle: { "margin-left": "7px" }
        },
        [_vm._v(" " + _vm._s(_vm.coLabel))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a6acf52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a6acf52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/multi-select/search-selected-item/template.html
// module id = null
// module chunks = 